import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var ConsoleAnalytics = /*#__PURE__*/function () {
  // eslint-disable-next-line no-console
  function ConsoleAnalytics() {
    var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console.log;

    _classCallCheck(this, ConsoleAnalytics);

    this.logger = logger;
  }

  _createClass(ConsoleAnalytics, [{
    key: "sendEvent",
    value: function sendEvent(category, action, label) {
      this.logger({
        category: category,
        action: action,
        label: label
      });
    }
  }]);

  return ConsoleAnalytics;
}();

export default ConsoleAnalytics;